import React, { memo } from 'react';
import theme from '../../theme';
import { NativeBaseProvider } from 'native-base';
import { Card, OfferCardContextProvider } from '../../commonoffer';
export default /*#__PURE__*/memo(_ref => {
  let {
    card,
    onDeepLink,
    requestedBy,
    logUserEvent,
    cardType
  } = _ref;
  return /*#__PURE__*/React.createElement(NativeBaseProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(OfferCardContextProvider, {
    onDeepLink: onDeepLink,
    requestedBy: requestedBy,
    logUserEvent: logUserEvent,
    cardType: cardType
  }, /*#__PURE__*/React.createElement(Card, card)));
});
//# sourceMappingURL=CommonOfferCard.js.map